import React, { useState } from "react";
import Table from "../Table";
import Button from "../../Elements/Buttons/Button";
import "./style.css";
import editIcon from "../../../Assets/Icons/edit-icon.svg";
import deleteIcon from "../../../Assets/Icons/delete-icon.svg";
import VisitModal from "../Modal/VisitModal";
import DeleteVisitRecord from "../Modal/DeleteVisitRecord";
let columns = [
  {
    id: 1,
    label: "Date",
    subText: "(of Test Taken)",
    isIcon: false,
    iconsList: [],
    sortingRequired: true,
  },
  {
    id: 2,
    label: "Files",
    subText: "(Reports & Documents)",
    isIcon: false,
    iconsList: [],
    sortingRequired: true,
  },
  {
    id: 3,
    label: "Notes/Recordings",
    subText: "(Notes or recordings by the doctor)",
    isIcon: false,
    iconsList: [],
    sortingRequired: true,
  },
  {
    id: 4,
    label: "Action",
    subText: "",
    isIcon: false,
    iconsList: [],
    sortingRequired: false,
  },
];

const rows = [
  {
    _id: 11,
    disabled: false,
    tableData: [
      {
        id: 1,
        text: "08 Aug 2023",
        subText: "",
        subYellowButton: "",
        subGreyButton: "",
        star: {
          isSubStar: false,
          isStarred: false,
        },
        isButton: false,
        disableButton: "",
        buttonList: [],
        containsProfileImage: false,
      },
      {
        id: 2,
        text: "CT Report",
        subText: "",
        subYellowButton: "",
        subGreyButton: "",
        star: {
          isSubStar: false,
          isStarred: false,
        },
        disableButton: "",
        isButton: false,
        buttonList: [],
        containsProfileImage: false,
      },
      {
        id: 3,
        text: "Lorem Ipsum has been the industry's standard.",
        subText: "",
        subYellowButton: "",
        subGreyButton: "",
        star: {
          isSubStar: false,
          isStarred: false,
        },
        disableButton: "",
        isButton: false,
        buttonList: [],
        containsProfileImage: false,
      },
      {
        id: 4,
        text: "",
        subText: "",
        subYellowButton: "",
        subGreyButton: "",
        star: {
          isSubStar: false,
          isStarred: false,
        },
        isButton: true,
        disableButton: "",
        buttonList: [
          {
            btntext: "",
            btnIcon: editIcon,
            btnAction: "edit",
          },
          {
            btntext: "",
            btnIcon: deleteIcon,
            btnAction: "delete",
          },
        ],
        containsProfileImage: false,
      },
    ],
  },
  {
    _id: 12,
    disabled: false,
    tableData: [
      {
        id: 1,
        text: "03 Aug 2023",
        subText: "",
        subYellowButton: "",
        subGreyButton: "",
        star: {
          isSubStar: false,
          isStarred: false,
        },
        isButton: false,
        disableButton: "",
        buttonList: [],
        containsProfileImage: false,
      },
      {
        id: 2,
        text: "CT Report",
        subText: "",
        subYellowButton: "",
        subGreyButton: "",
        star: {
          isSubStar: false,
          isStarred: false,
        },
        disableButton: "",
        isButton: false,
        buttonList: [],
        containsProfileImage: false,
      },
      {
        id: 3,
        text: "Lorem Ipsum has been the industry's standard dummy text.",
        subText: "",
        subYellowButton: "",
        subGreyButton: "",
        star: {
          isSubStar: false,
          isStarred: false,
        },
        disableButton: "",
        isButton: false,
        buttonList: [],
        containsProfileImage: false,
      },
      {
        id: 4,
        text: "",
        subText: "",
        subYellowButton: "",
        subGreyButton: "",
        star: {
          isSubStar: false,
          isStarred: false,
        },
        isButton: true,
        disableButton: "",
        buttonList: [
          {
            btntext: "",
            btnIcon: editIcon,
          },
          {
            btntext: "",
            btnIcon: deleteIcon,
          },
        ],
        containsProfileImage: false,
      },
    ],
  },
  {
    _id: 13,
    disabled: false,
    tableData: [
      {
        id: 1,
        text: "21 Jul 2023",
        subText: "",
        subYellowButton: "",
        subGreyButton: "",
        star: {
          isSubStar: false,
          isStarred: false,
        },
        isButton: false,
        disableButton: "",
        buttonList: [],
        containsProfileImage: false,
      },
      {
        id: 2,
        text: "MRI Report",
        subText: "",
        subYellowButton: "",
        subGreyButton: "",
        star: {
          isSubStar: false,
          isStarred: false,
        },
        disableButton: "",
        isButton: false,
        buttonList: [],
        containsProfileImage: false,
      },
      {
        id: 3,
        text: "Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown.",
        subText: "",
        subYellowButton: "",
        subGreyButton: "",
        star: {
          isSubStar: false,
          isStarred: false,
        },
        disableButton: "",
        isButton: false,
        buttonList: [],
        containsProfileImage: false,
      },
      {
        id: 4,
        text: "",
        subText: "",
        subYellowButton: "",
        subGreyButton: "",
        star: {
          isSubStar: false,
          isStarred: false,
        },
        isButton: true,
        disableButton: "",
        buttonList: [
          {
            btntext: "",
            btnIcon: editIcon,
          },
          {
            btntext: "",
            btnIcon: deleteIcon,
          },
        ],
        containsProfileImage: false,
      },
    ],
  },
  {
    _id: 14,
    disabled: false,
    tableData: [
      {
        id: 1,
        text: "06 Jul 2023",
        subText: "",
        subYellowButton: "",
        subGreyButton: "",
        star: {
          isSubStar: false,
          isStarred: false,
        },
        isButton: false,
        disableButton: "",
        buttonList: [],
        containsProfileImage: false,
      },
      {
        id: 2,
        text: "MRI Report",
        subText: "",
        subYellowButton: "",
        subGreyButton: "",
        star: {
          isSubStar: false,
          isStarred: false,
        },
        disableButton: "",
        isButton: false,
        buttonList: [],
        containsProfileImage: false,
      },
      {
        id: 3,
        text: "Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it.",
        subText: "",
        subYellowButton: "",
        subGreyButton: "",
        star: {
          isSubStar: false,
          isStarred: false,
        },
        disableButton: "",
        isButton: false,
        buttonList: [],
        containsProfileImage: false,
      },
      {
        id: 4,
        text: "",
        subText: "",
        subYellowButton: "",
        subGreyButton: "",
        star: {
          isSubStar: false,
          isStarred: false,
        },
        isButton: true,
        disableButton: "",
        buttonList: [
          {
            btntext: "",
            btnIcon: editIcon,
          },
          {
            btntext: "",
            btnIcon: deleteIcon,
          },
        ],
        containsProfileImage: false,
      },
    ],
  },
  {
    _id: 15,
    tableData: [
      {
        id: 1,
        text: "08 Aug 2023",
        subText: "",
        subYellowButton: "",
        subGreyButton: "",
        star: {
          isSubStar: false,
          isStarred: false,
        },
        isButton: false,
        disableButton: "",
        buttonList: [],
        containsProfileImage: false,
      },
      {
        id: 2,
        text: "CT Report",
        subText: "",
        subYellowButton: "",
        subGreyButton: "",
        star: {
          isSubStar: false,
          isStarred: false,
        },
        disableButton: "",
        isButton: false,
        buttonList: [],
        containsProfileImage: false,
      },
      {
        id: 3,
        text: "Lorem Ipsum has been the industry's standard.",
        subText: "",
        subYellowButton: "",
        subGreyButton: "",
        star: {
          isSubStar: false,
          isStarred: false,
        },
        disableButton: "",
        isButton: false,
        buttonList: [],
        containsProfileImage: false,
      },
      {
        id: 4,
        text: "",
        subText: "",
        subYellowButton: "",
        subGreyButton: "",
        star: {
          isSubStar: false,
          isStarred: false,
        },
        isButton: true,
        disableButton: "",
        buttonList: [
          {
            btntext: "",
            btnIcon: editIcon,
          },
          {
            btntext: "",
            btnIcon: deleteIcon,
          },
        ],
        containsProfileImage: false,
      },
    ],
  },
  {
    _id: 16,
    disabled: false,
    tableData: [
      {
        id: 1,
        text: "03 Aug 2023",
        subText: "",
        subYellowButton: "",
        subGreyButton: "",
        star: {
          isSubStar: false,
          isStarred: false,
        },
        isButton: false,
        disableButton: "",
        buttonList: [],
        containsProfileImage: false,
      },
      {
        id: 2,
        text: "CT Report",
        subText: "",
        subYellowButton: "",
        subGreyButton: "",
        star: {
          isSubStar: false,
          isStarred: false,
        },
        disableButton: "",
        isButton: false,
        buttonList: [],
        containsProfileImage: false,
      },
      {
        id: 3,
        text: "Lorem Ipsum has been the industry's standard dummy text.",
        subText: "",
        subYellowButton: "",
        subGreyButton: "",
        star: {
          isSubStar: false,
          isStarred: false,
        },
        disableButton: "",
        isButton: false,
        buttonList: [],
        containsProfileImage: false,
      },
      {
        id: 4,
        text: "",
        subText: "",
        subYellowButton: "",
        subGreyButton: "",
        star: {
          isSubStar: false,
          isStarred: false,
        },
        isButton: true,
        disableButton: "",
        buttonList: [
          {
            btntext: "",
            btnIcon: editIcon,
          },
          {
            btntext: "",
            btnIcon: deleteIcon,
          },
        ],
        containsProfileImage: false,
      },
    ],
  },
  {
    _id: 17,
    disabled: false,
    tableData: [
      {
        id: 1,
        text: "21 Jul 2023",
        subText: "",
        subYellowButton: "",
        subGreyButton: "",
        star: {
          isSubStar: false,
          isStarred: false,
        },
        isButton: false,
        disableButton: "",
        buttonList: [],
        containsProfileImage: false,
      },
      {
        id: 2,
        text: "MRI Report",
        subText: "",
        subYellowButton: "",
        subGreyButton: "",
        star: {
          isSubStar: false,
          isStarred: false,
        },
        disableButton: "",
        isButton: false,
        buttonList: [],
        containsProfileImage: false,
      },
      {
        id: 3,
        text: "Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown.",
        subText: "",
        subYellowButton: "",
        subGreyButton: "",
        star: {
          isSubStar: false,
          isStarred: false,
        },
        disableButton: "",
        isButton: false,
        buttonList: [],
        containsProfileImage: false,
      },
      {
        id: 4,
        text: "",
        subText: "",
        subYellowButton: "",
        subGreyButton: "",
        star: {
          isSubStar: false,
          isStarred: false,
        },
        isButton: true,
        disableButton: "",
        buttonList: [
          {
            btntext: "",
            btnIcon: editIcon,
          },
          {
            btntext: "",
            btnIcon: deleteIcon,
          },
        ],
        containsProfileImage: false,
      },
    ],
  },
  {
    _id: 18,
    disabled: false,
    tableData: [
      {
        id: 1,
        text: "06 Jul 2023",
        subText: "",
        subYellowButton: "",
        subGreyButton: "",
        star: {
          isSubStar: false,
          isStarred: false,
        },
        isButton: false,
        disableButton: "",
        buttonList: [],
        containsProfileImage: false,
      },
      {
        id: 2,
        text: "MRI Report",
        subText: "",
        subYellowButton: "",
        subGreyButton: "",
        star: {
          isSubStar: false,
          isStarred: false,
        },
        disableButton: "",
        isButton: false,
        buttonList: [],
        containsProfileImage: false,
      },
      {
        id: 3,
        text: "Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it.",
        subText: "",
        subYellowButton: "",
        subGreyButton: "",
        star: {
          isSubStar: false,
          isStarred: false,
        },
        disableButton: "",
        isButton: false,
        buttonList: [],
        containsProfileImage: false,
      },
      {
        id: 4,
        text: "",
        subText: "",
        subYellowButton: "",
        subGreyButton: "",
        star: {
          isSubStar: false,
          isStarred: false,
        },
        isButton: true,
        disableButton: "",
        buttonList: [
          {
            btntext: "",
            btnIcon: editIcon,
          },
          {
            btntext: "",
            btnIcon: deleteIcon,
          },
        ],
        containsProfileImage: false,
      },
    ],
  },
];

const PatientVisitRecords = ({
  PatientInfo = {
    name: "Anubhav Singh",
    age: "28",
    gender: "M",
    patientId: "ABC12345",
    type: "Referred",
    imgUrl: "",
  },
  handleBack,
}) => {
  const [isAddNewRecordModalOpen, setAddNewRecordModalOpen] = useState(false);
  const [isEditRecordModalOpen, setEditRecordModalOpen] = useState(false);
  const [isDeleteRecordModalOpen, setDeleteRecordModalOpen] = useState(false);

  const openAddNewRecordModal = () => {
    setAddNewRecordModalOpen(true);
  };

  const handleButtonClick = (row, btnIndex) => {
    const button = row.tableData[3].buttonList[btnIndex];
    if (button.btnAction === "edit") {
      setEditRecordModalOpen(true);
    } else if (button.btnAction === "delete") {
      setDeleteRecordModalOpen(true);
    }
  };

  return (
    <div className="patient-visit-records-frame">
      <div className="PVR-heading-frame">
        <h6 className="h6-400 dark-grey">Patient Visits Records</h6>
        <div className="PVR-options-frame">
          <Button btnType="addnewrecord" onClick={openAddNewRecordModal} />
          <Button btnType="back" onClick={handleBack} />
        </div>
      </div>
      <Table
        columnList={columns}
        rowList={rows}
        screen="patient-details"
        onButtonClick={handleButtonClick}
        view="expanded"
      />
      {/* Show Add New Record Modal when add new record button is clicked */}
      {isAddNewRecordModalOpen && (
        <VisitModal
          type="add"
          isOpen={isAddNewRecordModalOpen}
          onClose={() => setAddNewRecordModalOpen(false)}
          patientInfo={PatientInfo}
        />
      )}
      {/* Show Edit Record Modal when edit button in the table is clicked*/}
      {isEditRecordModalOpen && (
        <VisitModal
          type="edit"
          isOpen={isEditRecordModalOpen}
          onClose={() => setEditRecordModalOpen(false)}
          patientInfo={PatientInfo}
        />
      )}
      {/* Show Delete Record Modal when delete button in the table is clicked*/}
      {isDeleteRecordModalOpen && (
        <DeleteVisitRecord
          isOpen={isDeleteRecordModalOpen}
          onClose={() => setDeleteRecordModalOpen(false)}
        />
      )}
    </div>
  );
};

export default PatientVisitRecords;
